import React, { useRef, useState } from "react";
import { createPortal } from "react-dom";
import { KBD } from "../utils/Keybindings";
import { kbdEvent } from "../utils/Utils";

export default function NumberPicker({ children, onSelect, active = false, offset = [0, 0] }) {
    const ref = useRef(null);
    const [visible, setVisible] = useState(false);
    const [pos, setPos] = useState({ top: 0, left: 0 });


    function NumberGrid({ pos, onSelect, onMouseEnter, onMouseLeave }) {
        const nums = [1, 2, 3, 4, 5, 6, 7, 8, 9, 0];

        if (!active) {
            return;
        }

        return (
            <div
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
                style={{
                    position: "absolute",
                    top: pos.top + offset[0],
                    left: pos.left + offset[1],
                    background: "var(--text-black)",
                    border: "1px solid var(--border-secondary)",
                    padding: 1,
                    boxShadow: "0 0px 12px rgba(0,0,0,0.7)",
                    zIndex: 999999,
                    display: "grid",
                    gridTemplateColumns: "repeat(3, 25px)",
                    gap: 1,
                }}
            >
                {nums.map((n) => (
                    <div
                        role="button"
                        tabIndex={0}
                         style={n === 0 ? { gridColumn: "1 / -1" } : undefined}
                        className="ui-num-picker-btn"
                        onKeyDown={(e) => {
                            if (e.key === "Enter" || e.key === " ") {
                                kbdEvent(KBD.Digit1);
                                onSelect(n);
                            }
                        }}
                        onMouseDown={(e) => {
                            e.preventDefault();
                            kbdEvent(KBD.Digit1);
                            onSelect(n);
                        }}
                    >
                        {n}
                    </div>
                ))}

                
            </div>
        );
    }

    const show = () => {
        if (!ref.current) return;

        const r = ref.current.getBoundingClientRect();

        setPos({
            top: r.bottom + window.scrollY,
            left: r.left + window.scrollX,
        });

        setVisible(true);
    };

    const hide = () => setVisible(false);

    return (
        <>
            <div
                ref={ref}
                onMouseEnter={show}
                onMouseLeave={hide}
                style={{ display: "inline-block" }}
            >
                {children}
            </div>

            {visible &&
                createPortal(
                    <>
                    <NumberGrid
                        pos={pos}
                        onSelect={(n) => onSelect?.(n)}
                        onMouseEnter={() => setVisible(true)}
                        onMouseLeave={hide}
                    />
                    </>,
                    document.body
                )}
        </>
    );
}